module.exports = __webpack_public_path__ + "img/work-from-home.6df06691.svg";